import { logger } from "@justhome/common";
import {
  Assumptions,
  GetAssumptionsVariables,
  fetchGetAssumptions,
} from "@justhome/api-core";

export async function fetchGetAssumptionsWithLogging(
  variables: GetAssumptionsVariables,
): Promise<Assumptions> {
  try {
    return await fetchGetAssumptions(variables);
  } catch (error) {
    logger.error("Error while getting all assumptions.", error, variables);
    throw error;
  }
}
